import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Text, TextStyle } from "pixi.js";

export class SignMessageTextContainer extends Container {
    private static readonly MESSAGE_TEXT = "SIGN THE MESSAGE IN YOUR WALLET";
    private static readonly TO_TEXT = "TO";
    private static readonly LOGIN_TEXT = "LOG IN";

    private messageText: Text;
    private toText: Text;
    private loginText: Text;

    public constructor() {
        super();
        this.build();
        this.layout();
    }

    private build(): void {
        this.messageText = new Text(SignMessageTextContainer.MESSAGE_TEXT, new DescriptionTextStyle());
        this.toText = new Text(SignMessageTextContainer.TO_TEXT, new DescriptionTextStyle());
        this.loginText = new Text(SignMessageTextContainer.LOGIN_TEXT, new DescriptionTextStyle());
        this.loginText.style.fill = ['AAFD09', '16CF15'];
        this.loginText.style.fillGradientType = 1;

        this.addChild(
            this.messageText,
            this.toText,
            this.loginText
        );
    }

    private layout(): void {
        this.toText.position.set(180, 46);
        this.loginText.position.set(223, 46);
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 46,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.7,
            dropShadowBlur: 5,
            dropShadowDistance: 3,
            dropShadowColor: '0D0606'
        });
    }
}